/* eslint-disable lodash/prefer-lodash-method */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Input, Label, Icon, Form, Popup } from 'semantic-ui-react';

import { validateHashtags } from './utils';

const inputStyle = { marginBottom: 10 };
const inputAction = { icon: 'plus' };
const requiredLabelStyle = { color: 'red' };
const tagStyles = { marginTop: 4 };

const RequiredLabel = () => (<span style={requiredLabelStyle}>*</span>);

const HelpPopup = () => <Popup
  content="enter hashtags, @mentions or any text you want to use to capture the influencer posts.
    You can enter multiple entries separated by commas.
    The system will search the post or story caption and add the post to the campaign if it matches.
    Hashtags must be more than 2 characters"
  trigger={<Icon name="help circle" className="circular" />}
/>;

export default class HashtagsInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      tags: props.hashtags,
      error: null,
    };
  }

  onAddHashTagCallback = e => {
    e.preventDefault();
    const {
      maxTags,
      onValueChanged,
    } = this.props;
    const {
      value = '',
      tags,
    } = this.state;


    const tagsClone = _.clone(tags);
    const multipleTags = value.split(',').filter(v => !_.isEmpty(v));
    tagsClone.push(...multipleTags);

    if (_.size(tags) + _.size(multipleTags) > maxTags) {
      this.setState(state => ({
        ...state,
        error: `You can add up to ${maxTags} hashtags, mentions, or text entries only.` }),
      );
      return;
    }

    this.setState({
      tags: tagsClone,
      value: '',
    }, () => {
      onValueChanged(e, {
        name: 'hashtags',
        value: _.join(tagsClone, ','),
      });
    });
  }

 onTextInputChange = (e, { value }) => {
   this.setState({
     value: _.replace(value, / +/g, ''),
   });
 }

 resetInputError = () => {
   this.setState(state => ({ ...state, error: null }));
 }

  onDeleteTag = tagToRemove => {
    const { tags } = this.state;
    const newTags = _.reject(tags, tag => tag === tagToRemove);
    this.setState({
      tags: newTags,
    }, () => {
      this.props.onValueChanged({}, {
        name: 'hashtags',
        value: _.join(newTags, ','),
      });
    });
  }

  render() {
    const {
      maxTags,
      campaignType,
    } = this.props;

    const {
      value,
      tags,
      error,
    } = this.state;

    const isAutomated = campaignType === 'AUTOMATED';

    const validationResult = validateHashtags(value);

    const isValidInput = validationResult.valid;

    const shouldDisableAddButton = _.toNumber(maxTags) === _.size(tags);

    const actionProps = {
      onClick: this.onAddHashTagCallback,
      ...inputAction,
      disabled: shouldDisableAddButton || !isValidInput,
    };

    return (
      <Form.Field>
        {
          isAutomated &&
          <label htmlFor="campaign-hashtags">
            Tracked <i>#hashtag</i> or <i>@mention</i> (max. {maxTags})
            <RequiredLabel />  <HelpPopup />
          </label>
        }
        {
          !isAutomated &&
          <label htmlFor="campaign-hashtags">
            #Hashtags (max. {maxTags})  <HelpPopup />
          </label>
        }
        <Input
          action={actionProps}
          onChange={this.onTextInputChange}
          placeholder={shouldDisableAddButton ? 'max tags added' : 'e.g. #nike'}
          value={value}
          onBlur={this.resetInputError}
          onFocus={this.resetInputError}
          style={inputStyle}
          disabled={shouldDisableAddButton}
        />
        {
          error ? (
            <Label basic color="red" pointing>
              {error}
            </Label>) : null
        }
        {
          _.map(tags, tag => (
            <Label image size="large" basic style={tagStyles}>
              { tag }
              <Icon name="delete" color="red" onClick={() => this.onDeleteTag(tag)} />
            </Label>
          ))
        }
      </Form.Field>
    );
  }
}

HashtagsInput.propTypes = {
  maxTags: PropTypes.number,
  hashtags: PropTypes.array,
  onValueChanged: PropTypes.func.isRequired,
  campaignType: PropTypes.string,
};

HashtagsInput.defaultProps = {
  maxTags: 25,
  hashtags: [],
  campaignType: 'MANUAL',
};



/** WEBPACK FOOTER **
 ** ./src/components/hashtags-input/index.js
 **/